var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",[_c('a',{attrs:{"href":"#"}},[_vm._v("Löschen")])],{"deleting":_vm.deleting,"deleteBankAccount":_vm.deleteBankAccount})],2)}
var staticRenderFns = []

export { render, staticRenderFns }